import { StringService as StringHelper } from '@rocheglobal/component-library-dot-com/src/services/string/index';
import React from 'react';
import { useTranslation } from '../../hooks/use-translation';
import { SearchList } from '../../view/search-list';
import { Modal } from '../../view/search-list/modal';
import { fetchEventsList, fetchEventsTabs } from '../../view/search-list/queries';
import { RocheAddToCalendar } from './roche-add-to-calendar';

const getCalendarData = (item) => ({
  eventTitle: StringHelper.capitalize(item['Event Title']),
  description: StringHelper.capitalize(item['Event Text'] || ''),
  startDate: item['Start Date'].replace(/\s/, 'T'),
  endDate: item['End Date'].replace(/\s/, 'T'),
});

export const RocheMediaEventsList = ({ slot }: any): JSX.Element => {
  const buttonLabel = useTranslation('add to calendar');
  const teaserOverline = (item) => `
    ${item.startDate} ${item.Timezone}${item.Location !== null && item.Location !== '' ? ` | ${item.Location}` : ''}
  `;

  return (
    <SearchList slot={slot} tabName='year' pageName='page' fetchTabs={fetchEventsTabs} fetchList={fetchEventsList}>
      {({ items }) => (
        <>
          {items &&
            items.map((item, index) => (
              <roche-teaser
                key={`${item['Start Date']}-${index}`}
                slot='left'
                layout='teaser--card-c'
                teaser-title={StringHelper.capitalize(item['Event Title'])}
                teaser-overline={teaserOverline(item)}
                teaser-url={item.Link}
                force-align-left={true}
              >
                {item['Add to Calendar'] === 'TRUE' && (
                  <Modal
                    slot='secondary-action'
                    trigger={
                      <roche-button
                        no-margin
                        appearance='tertiary'
                        left-icon='calendar'
                        id={`${index}`}
                        text={StringHelper.capitalize(buttonLabel)}
                      />
                    }
                  >
                    <RocheAddToCalendar eventItem={getCalendarData(item)} />
                  </Modal>
                )}
              </roche-teaser>
            ))}
        </>
      )}
    </SearchList>
  );
};
